import React, { useEffect } from 'react';
import * as Bixby from '$/core';
import { connect } from 'react-redux';
import { AppState } from '$/store';
import { getTransactionComps } from '$/store/transactioncomps/actions';
import { getIsCurrentUserAdminState } from '$/store/profile/selectors';
import HeadingBlock from '$/components/global/heading';
import Loading from '$/components/loading/Loading';
import NoDataFound from '$/components/global/noData';
import './index.scss';
import { TransactionCompsGrid } from '$/components/transaction-comps-grid';

interface ITransactionCompsProps {
  isLoading: boolean;
  isAdmin: boolean;
  transactionComps?: Bixby.Models.CompanyTransactionComp[];

  dispatchGetTransactionComps(): () => Promise<void>;
}

const TransactionComps: React.FC<ITransactionCompsProps> = props => {
  const { isLoading, isAdmin, transactionComps, dispatchGetTransactionComps } = props;

  useEffect(() => {
    dispatchGetTransactionComps();
  }, [dispatchGetTransactionComps]);

  if (transactionComps && !Bixby.Utils.isNullOrEmpty(transactionComps)) {
    return (
      <section className="transaction_comps">
        <HeadingBlock title="Transaction Comps" />
        <div className="transaction_comps_data_grid">
          <TransactionCompsGrid gridData={transactionComps} isAdmin={isAdmin} />
        </div>
      </section>
    );
  } else if (isLoading) {
    return <Loading pageLevel />;
  } else {
    return (
      <>
        <HeadingBlock title="Transaction Comps" />
        <div className="no-data-found">
          <NoDataFound dataType="companies" />
        </div>
      </>
    );
  }
};

const mapStateToProps = (state: AppState) => {
  const { isAdmin } = getIsCurrentUserAdminState(state);
  return {
    transactionComps: state.transactionCompsState.transactionComps,
    isLoading: state.transactionCompsState.isLoading,
    isAdmin,
    error: state.transactionCompsState.error,
  };
};

const mapDispatchToProps = (dispatch: any) => ({
  dispatchGetTransactionComps: () => dispatch(getTransactionComps()),
});

export default connect(mapStateToProps, mapDispatchToProps)(TransactionComps);
